define('common/baseController',['require','glu/controller'],function(require) {
	'use strict';

	var Controller = require('glu/controller');

	return Controller.extend({
		initialize: function() {
			//any global controller functions here.
		}
	});
});

